import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Button,
  Switch,
} from "@mui/material";

import { Row, Col, FormGroup, Alert, Label } from "reactstrap";
import { AvForm, AvField, AvGroup } from "availity-reactstrap-validation";

import TextField from "@mui/material/TextField";

import { updateOrgBilling } from "../../../store/organizationBilling/organizationBillingSlice";

import { formatDateToUTCString } from "./../../../utilities/dateConversion";

import spinner from "../../../assets/images/loadingGif.gif";

import { makeStyles } from "@mui/styles";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { commonStyles } from '../../../theme';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const useStyles = makeStyles((theme) => ({
  ...commonStyles,
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflowY: "auto",
    maxHeight: "100vh",
  },
}));

const updateOrgBillingEmptyFormState = {
  billingId: "",
  // orgcode: "",
  accountNumber: "",
  customerIdentifier: "",
  dateFrom: "",
  dateTo: "",
  proratedDays: "",
  cloudSpend: "",
  usageAmount: "",
  subscriptionType: "",
  contractAmount: "",
  additionalAmount: "",
  thresholdAmount: "",
  totalAmount: "",
  isApproved: "",
  isDeleted: "",
  usagePercentage: "",
};

const UpdateOrganizationBilling = (props) => {
  console.log("UpdateOrganizationAccount props: ", props)
  const classes = useStyles();
  const { 
    open,
    onClose,
    updateOrgBillingRecord,
    orgCode
  } = props;

  const [updateOrgBillingFormState, setUpdateOrgBillingFormState] = useState({
      ...updateOrgBillingEmptyFormState,
      billingId: updateOrgBillingRecord.billingId,
      // orgcode: orgCode,
      accountNumber: updateOrgBillingRecord.accountNumber,
      customerIdentifier: updateOrgBillingRecord.customerIdentifier,
      // dateFrom: updateOrgBillingRecord.dateFrom,
      dateFrom: new Date(updateOrgBillingRecord.dateFrom).toISOString(),
      // dateTo: updateOrgBillingRecord.dateTo,
      dateTo: new Date(updateOrgBillingRecord.dateTo).toISOString(),
      proratedDays: ""+updateOrgBillingRecord.proratedDays,
      cloudSpend: ""+updateOrgBillingRecord.cloudSpend,
      usageAmount: ""+updateOrgBillingRecord.usageAmount,
      subscriptionType: updateOrgBillingRecord.subscriptionType,
      contractAmount: ""+updateOrgBillingRecord.contractAmount,
      additionalAmount: ""+updateOrgBillingRecord.additionalAmount,
      thresholdAmount: ""+updateOrgBillingRecord.thresholdAmount,
      totalAmount: ""+updateOrgBillingRecord.totalAmount,
      isApproved: updateOrgBillingRecord.isApproved,
      isDeleted: updateOrgBillingRecord.isDeleted,
      usagePercentage: ""+updateOrgBillingRecord.usagePercentage,
      overageAmount: ""+updateOrgBillingRecord.overage_amount,
    }
  );

  const isUpdateOrgBillingFormInvalid = () => { 
    const isInvalidItems = [
      {
        field: "billingId",
        isInvalid: updateOrgBillingFormState.billingId === "" ? true : false,
      },
      {
        field: "customerIdentifier",
        isInvalid: updateOrgBillingFormState.customerIdentifier === "" ? true : false,
      },
      {
        field: "dateFrom",
        isInvalid: updateOrgBillingFormState.dateFrom === "" ? true : false,
      },
      {
        field: "dateTo",
        isInvalid: updateOrgBillingFormState.dateTo === "" ? true : false,
      },
      {
        field: "proratedDays",
        isInvalid: updateOrgBillingFormState.proratedDays === "" ? true : false,
      },
      {
        field: "cloudSpend",
        isInvalid: updateOrgBillingFormState.cloudSpend === "" ? true : false,
      },
      {
        field: "usageAmount",
        isInvalid: updateOrgBillingFormState.usageAmount === "" ? true : false,
      },
      {
        field: "contractAmount",
        isInvalid: updateOrgBillingFormState.contractAmount === "" ? true : false,
      },
      {
        field: "additionalAmount",
        isInvalid: updateOrgBillingFormState.additionalAmount === "" ? true : false,
      },
      {
        field: "thresholdAmount",
        isInvalid: updateOrgBillingFormState.thresholdAmount === "" ? true : false,
      },
      {
        field: "totalAmount",
        isInvalid: updateOrgBillingFormState.totalAmount === "" ? true : false,
      },
      {
        field: "usagePercentage",
        isInvalid: updateOrgBillingFormState.usagePercentage === "" ? true : false,
      },
    ];

    return isInvalidItems?.filter((item) => item.isInvalid)?.length > 0;
  }

  const handleUpdateOrgBilling = (e) => {
    const { overageAmount, ...filteredPayload } = updateOrgBillingFormState;

    console.log("updateOrgBillingPayload before conversion: ", filteredPayload);
    filteredPayload.dateFrom = formatDateToUTCString(new Date(filteredPayload.dateFrom));
    filteredPayload.dateTo = formatDateToUTCString(new Date(filteredPayload.dateTo));

    console.log("updateOrgBillingPayload after conversion: ", filteredPayload);
    // Make API Call
    props.updateOrgBilling(filteredPayload);
  };


  const clearUpdateFormState = () => {
    setUpdateOrgBillingFormState(updateOrgBillingEmptyFormState);
  };

    //For displaying message for updating organization
    let updateOrgBillingMessage = props.updateOrgBillingMessage;
    useEffect(() => {
      console.log("updateOrgBillingMessage = " + updateOrgBillingMessage);
      if (updateOrgBillingMessage) {
        console.log(
          "Inside if, updateOrgBillingMessage = " + updateOrgBillingMessage
        );
        //Clear state variables associated with the form
        clearUpdateFormState();
      }
    }, [updateOrgBillingMessage]);


  return (
    <Modal className={classes.modal} open={open} onClose={onClose} disableAutoFocus disableEnforceFocus>
      <div className={classes.paper} style={{ height: "600px" }}>
        <h3>Update Organization Billing</h3>
        {props.isUpdatingOrgBilling && (
          <div style={{ display: "flex", alignContent: "center", justifyContent: "center" }}>
            <img src={spinner} width="32px" alt="Spinner" />
          </div>
        )}
        {/* Error message */}
        {props.updateOrgBillingError && (
          <Alert className="mt-3 mb-0" color="danger">
            Error while updating organization billing. {JSON.stringify(props.updateOrgBillingError?.message)}
          </Alert>
        )}
        <AvForm>
          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            <Row>
              <Col lg="6">
                <FormGroup>
                  <Label for="dateFrom">Date From</Label>
                  <DatePicker
                    selected={updateOrgBillingFormState.dateFrom ? new Date(updateOrgBillingFormState.dateFrom) : null}
                    onChange={(date) => setUpdateOrgBillingFormState({
                      ...updateOrgBillingFormState,
                      dateFrom: date
                    })}
                    className="form-control"
                    dateFormat="MM/dd/yyyy"
                    placeholderText="Select start date"
                  />
                </FormGroup>
              </Col>
              <Col lg="6">
                <FormGroup>
                  <Label for="dateTo">Date To</Label>
                  <DatePicker
                    selected={updateOrgBillingFormState.dateTo ? new Date(updateOrgBillingFormState.dateTo) : null}
                    onChange={(date) => setUpdateOrgBillingFormState({
                      ...updateOrgBillingFormState,
                      dateTo: date
                    })}
                    className="form-control"
                    dateFormat="MM/dd/yyyy"
                    placeholderText="Select end date"
                    minDate={updateOrgBillingFormState.dateFrom ? new Date(updateOrgBillingFormState.dateFrom) : null}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col lg="6">
                <FormGroup>
                  <Label for="proratedDays">Prorated Days</Label>
                  <AvField
                    name="proratedDays"
                    value={updateOrgBillingFormState.proratedDays}
                    onChange={(e) => setUpdateOrgBillingFormState({...updateOrgBillingFormState, proratedDays:e.target.value})}
                    type="number"
                    errorMessage="Enter prorated Days"
                    validate={{
                      required: {value: true},
                    }}
                    id="proratedDays"
                    placeholder="Prorated Days"
                  />
                </FormGroup>
              </Col>
              <Col lg="6">
                <FormGroup>
                    <Label for="subscriptionType">Subscription Type</Label>
                    <AvField
                      type="select"
                      name="subscriptionType"
                      value={updateOrgBillingFormState.subscriptionType}
                      onChange={(e) => setUpdateOrgBillingFormState({...updateOrgBillingFormState, subscriptionType:e.target.value})}
                      id="subscriptionType"
                    >
                      {[
                          "ASSISTED TRIAL",
                          "ASSISTED PAID",
                          "AWS PAID PUBLIC",
                          "AWS PAID PRIVATE",
                          "AWS TRIAL",
                          "ASSISTED CUSTOM",
                        ].map((type) => (
                          <option key={type} value={type}>
                            {type}
                          </option>
                      ))}
                    </AvField>
                  </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col lg="6">
                <FormGroup>
                  <Label for="cloudSpend">Cloud Spend</Label>
                  <AvField
                    name="cloudSpend"
                    value={updateOrgBillingFormState.cloudSpend}
                    onChange={(e) => setUpdateOrgBillingFormState({...updateOrgBillingFormState, cloudSpend:e.target.value})}
                    type="number"
                    errorMessage="Enter Cloud Spend"
                    validate={{
                      required: {value: true},
                    }}
                    id="cloudSpend"
                    placeholder="Cloud Spend"
                    disabled
                  />
                </FormGroup>
              </Col>
              <Col lg="6">
                <FormGroup>
                  <Label for="usagePercentage">Overage Percentage</Label>
                  <AvField
                    name="usagePercentage"
                    value={updateOrgBillingFormState.usagePercentage}
                    onChange={(e) => setUpdateOrgBillingFormState({...updateOrgBillingFormState, usagePercentage:e.target.value})}
                    type="number"
                    errorMessage="Enter Overage Percentage"
                    validate={{
                      required: {value: true},
                    }}
                    id="usagePercentage"
                    placeholder="Overage Percentage"
                    disabled
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col lg="6">
                <FormGroup>
                  <Label for="usageAmount">Usage Amount</Label>
                  <AvField
                    name="usageAmount"
                    value={updateOrgBillingFormState.usageAmount}
                    onChange={(e) => setUpdateOrgBillingFormState({...updateOrgBillingFormState, usageAmount:e.target.value})}
                    type="number"
                    errorMessage="Enter Usage Amount"
                    validate={{
                      required: {value: true},
                    }}
                    id="usageAmount"
                    placeholder="Usage Amount"
                    disabled
                  />
                </FormGroup>
              </Col>
              <Col lg="6">
                <FormGroup>
                  <Label for="thresholdAmount">Threshold Amount</Label>
                  <AvField
                    name="thresholdAmount"
                    value={updateOrgBillingFormState.thresholdAmount}
                    onChange={(e) => setUpdateOrgBillingFormState({...updateOrgBillingFormState, thresholdAmount:e.target.value})}
                    type="number"
                    errorMessage="Enter Threshold Amount"
                    validate={{
                      required: {value: true},
                    }}
                    id="thresholdAmount"
                    placeholder="Threshold Amount"
                    disabled
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col lg="6">
                <FormGroup>
                  <Label for="overageAmount">Overage Amount</Label>
                  <AvField
                    name="overageAmount"
                    value={updateOrgBillingFormState.overageAmount}
                    onChange={(e) => setUpdateOrgBillingFormState({...updateOrgBillingFormState, overageAmount:e.target.value})}
                    type="number"
                    errorMessage="Enter Overage Amount"
                    validate={{
                      required: {value: true},
                    }}
                    id="overageAmount"
                    placeholder="Overage Amount"
                    disabled
                  />
                </FormGroup>
              </Col>
              <Col lg="6">
                <FormGroup>
                  <Label for="additionalAmount">Compliance Charge</Label>
                  <AvField
                    name="additionalAmount"
                    value={updateOrgBillingFormState.additionalAmount}
                    onChange={(e) => setUpdateOrgBillingFormState({...updateOrgBillingFormState, additionalAmount:e.target.value})}
                    type="number"
                    errorMessage="Enter Compliance Charge"
                    validate={{
                      required: {value: true},
                    }}
                    id="additionalAmount"
                    placeholder="Compliance Charge"
                    disabled
                  />
                </FormGroup>
              </Col> 
            </Row>

            {/* <Row>
              <Col lg="6">
                <FormGroup>
                  <Label for="isApproved">Approved Status</Label>
                  <Switch
                    checked={updateOrgBillingFormState.isApproved}
                    onChange={(e) => setUpdateOrgBillingFormState({...updateOrgBillingFormState, isApproved:e.target.checked})}
                  />
                </FormGroup>
              </Col>
              <Col lg="6">
                <FormGroup>
                  <Label for="isDeleted">Delete Status</Label>
                  <Switch
                    checked={updateOrgBillingFormState.isDeleted}
                    onChange={(e) => setUpdateOrgBillingFormState({...updateOrgBillingFormState, isDeleted:e.target.checked})}
                  />
                </FormGroup>
              </Col>
            </Row> */}

            <Row>
              <Col lg="6">
                <FormGroup>
                  <Label for="totalAmount">Total Amount</Label>
                  <AvField
                    name="totalAmount"
                    value={updateOrgBillingFormState.totalAmount}
                    onChange={(e) => setUpdateOrgBillingFormState({...updateOrgBillingFormState, totalAmount:e.target.value})}
                    type="number"
                    errorMessage="Enter Total Amount"
                    validate={{
                      required: {value: true},
                    }}
                    id="totalAmount"
                    placeholder="Total Amount"
                  />
                </FormGroup>
              </Col>
              <Col lg="6">
                <FormGroup>
                  <Label for="contractAmount">Contract Amount</Label>
                  <AvField
                    name="contractAmount"
                    value={updateOrgBillingFormState.contractAmount}
                    onChange={(e) => setUpdateOrgBillingFormState({...updateOrgBillingFormState, contractAmount:e.target.value})}
                    type="number"
                    errorMessage="Enter Contract Amount"
                    validate={{
                      required: {value: true},
                    }}
                    id="contractAmount"
                    placeholder="Contract Amount"
                    disabled
                  />
                </FormGroup>
              </Col>
            </Row>

            <Button
              color="primary"
              variant="contained"
              disabled={isUpdateOrgBillingFormInvalid() || props.isUpdatingOrgBilling}
              onClick={handleUpdateOrgBilling}
            >
              Update Organization Billing
            </Button>
          </div>
        </AvForm>
      </div>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  const {
    isUpdatingOrgBilling,
    updateOrgBillingMessage,
    updateOrgBillingError,
  } = state.organizationBillingSlice;

  return {
    isUpdatingOrgBilling,
    updateOrgBillingMessage,
    updateOrgBillingError,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateOrgBilling: (updateOrgBillingPayload) => {
      dispatch(updateOrgBilling(updateOrgBillingPayload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateOrganizationBilling);
